import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Container, Typography, TextField, InputAdornment } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Search } from "@mui/icons-material";
import { useFetch, useCompanyListFilter } from "@/hooks";
import { companiesApi } from "@/api";
import CompanyCard from "@/components/CompanyCard";
import LoadingSpinner from "@/components/LoadingSpinner";

export default function Companies() {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const { data, loading, error } = useFetch(() => companiesApi.getAll(0, 100), []);

  const filtered = useCompanyListFilter(data?.items, search);

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          mb: 4,
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Box>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
            }}
          >
            {t("nav.companies")}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "text.secondary",
            }}
          >
            {data && `${data.total} ${t("nav.companies").toLowerCase()}`}
          </Typography>
        </Box>
        <TextField
          size="small"
          placeholder={t("company.searchPlaceholder")}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            },
          }}
          sx={{ minWidth: 280 }}
        />
      </Box>
      {loading && <LoadingSpinner />}
      {error && (
        <Typography
          color="error"
          sx={{
            textAlign: "center",
          }}
        >
          {error}
        </Typography>
      )}
      {filtered && (
        <Grid container spacing={3}>
          {filtered.map((company) => (
            <Grid size={{ xs: 12, md: 6 }} key={company.id}>
              <CompanyCard company={company} />
            </Grid>
          ))}
        </Grid>
      )}
      {filtered && filtered.length === 0 && (
        <Typography
          sx={{
            textAlign: "center",
            color: "text.secondary",
            py: 6,
          }}
        >
          {t("common.noResults")}
        </Typography>
      )}
    </Container>
  );
}
